import React from 'react';
import Work from '../components/Work';
import './Page.css';

function WorkPage() {
  return (
    <div className="page-container">
      <Work />
    </div>
  );
}

export default WorkPage;
